import React from "react";
import "./DayManagementFilter.css";

const DayManagementFilter = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  applyFilter,
}) => {
  return (
    <div className="day-management-filter">
      <label>
        Od:
        <input
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
        />
      </label>
      <label>
        Do:
        <input
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
        />
      </label>
      <button className="primary-button" onClick={applyFilter}>
        Filtruj
      </button>
    </div>
  );
};

export default DayManagementFilter;
